import { beaconAssert, beaconFail } from "./assertions.js";
import { DomUtils } from "./dom-utils.js";
import { PriceUtils } from "./price-utils.js";
import { setupBeacon } from "./setup-beacon.js";
import { beaconError, beaconLog, beaconWarn } from "./testing.js";
import { TextUtils } from "./text-utils.js";
import { UrlUtils } from "./url-utils.js";
export * from "./event-types.js";
export * from "./simple-callbacks.js";
const Raptor = {
    setupBeacon,
    beaconAssert,
    beaconFail,
    beaconLog,
    beaconWarn,
    beaconError,
    ...DomUtils,
    ...TextUtils,
    ...PriceUtils,
    ...UrlUtils,
};
export default Raptor;
//# sourceMappingURL=index.js.map